import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Courses from './pages/Courses';
import CourseDetail from './pages/CourseDetail';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Cart from './pages/Cart';
import Contact from './pages/Contact';
import Dashboard from './pages/Dashboard';
import Dod8140Training from './pages/Dod8140Training';
import Dod8140CoursePage from './pages/Dod8140CoursePage';
import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminCourses from './pages/admin/AdminCourses';
import AdminCategories from './pages/admin/AdminCategories';
import AdminVouchers from './pages/admin/AdminVouchers';
import AdminTestimonials from './pages/admin/AdminTestimonials';
import AdminUsers from './pages/admin/AdminUsers';
import AdminEnrollments from './pages/admin/AdminEnrollments';
import AdminContact from './pages/admin/AdminContact';
import AdminAdmins from './pages/admin/AdminAdmins';
import AdminSettings from './pages/admin/AdminSettings';
import AdminContent from './pages/admin/AdminContent';
import AdminSMTP from './pages/admin/AdminSMTP';
import AdminChatbot from './pages/admin/AdminChatbot';
import AdminDod8140 from './pages/admin/AdminDod8140';
import { AuthProvider, useAuth } from './lib/auth';
import { SettingsProvider } from './lib/settings';
import { Toaster } from './components/ui/toaster';
import ChatWidget from './components/ChatWidget';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [pathname]);
  return null;
}

function Shell({ children }) {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith('/admin');
  return (
    <>
      {!isAdmin && <Navbar />}
      <main>{children}</main>
      {!isAdmin && <Footer />}
      {!isAdmin && <ChatWidget />}
    </>
  );
}

function AdminGate({ children }) {
  const { user, loading, isAdmin } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center">Loading…</div>;
  if (!user) return <Navigate to="/login?redirect=/admin" replace />;
  if (!isAdmin) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SettingsProvider>
            <ScrollToTop />
            <Shell>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/courses" element={<Courses />} />
              <Route path="/course/:id" element={<CourseDetail />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/dod-8140-certification-training" element={<Dod8140Training />} />
              <Route path="/dod-8140/:slug" element={<Dod8140CoursePage />} />
              <Route path="/dashboard" element={<Dashboard />} />

              <Route path="/admin" element={<AdminGate><AdminLayout /></AdminGate>}>
                <Route index element={<AdminDashboard />} />
                <Route path="courses" element={<AdminCourses />} />
                <Route path="categories" element={<AdminCategories />} />
                <Route path="vouchers" element={<AdminVouchers />} />
                <Route path="testimonials" element={<AdminTestimonials />} />
                <Route path="users" element={<AdminUsers />} />
                <Route path="enrollments" element={<AdminEnrollments />} />
                <Route path="contact" element={<AdminContact />} />
                <Route path="admins" element={<AdminAdmins />} />
                <Route path="settings" element={<AdminSettings />} />
                <Route path="content" element={<AdminContent />} />
                <Route path="smtp" element={<AdminSMTP />} />
                <Route path="chatbot" element={<AdminChatbot />} />
                <Route path="dod-8140" element={<AdminDod8140 />} />
              </Route>
            </Routes>
          </Shell>
          <Toaster />
          </SettingsProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
